if (!customElements.get('bv-cart-recommendation')) {
  customElements.define('bv-cart-recommendation', class extends HTMLElement {
    connectedCallback() {
      this.revision = 0;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const revision = ++this.revision;
        if (Number.isInteger(event.cartData?.item_count) && Array.isArray(event.cartData.items)) {
          this.updateVisibility(event.cartData);
        } else {
          // Add responses contain only added lines, so read the complete bag before showing a suggestion.
          this.hidden = true;
          fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => {
              if (!response.ok) throw new Error('Cart unavailable');
              return response.json();
            })
            .then((cart) => { if (revision === this.revision) this.updateVisibility(cart); })
            .catch(() => { if (revision === this.revision) this.hidden = true; });
        }
      });
    }

    disconnectedCallback() {
      this.revision++;
      this.unsubscribe?.();
    }

    updateVisibility(cart) {
      this.hidden = !Number.isInteger(cart.item_count) || cart.item_count < 1 || !Array.isArray(cart.items) ||
        cart.items.some((item) => String(item.product_id) === this.dataset.productId);
    }
  });
}
